import React, { useState } from 'react';
import { Container, makeStyles, Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from '../ui_components/tab_panel';
import ArticlesList from './article/article_list';
import PercentageList from './percetages/percentage_list';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        minHeight: 600
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
        minWidth: 125
    },
    tab: {
        marginRight: theme.spacing(3)
    },
    tabPanel: {
        width: '100%'
    }
}));

const a11yProps = (index) => {
	return {
		id: `scrollable-force-tab-${index}`,
		'aria-controls': `scrollable-force-tabpanel-${index}`
	};
};

const ExpenseTabs = () => {
    const { container, paper, tabs, tab, tabPanel } = useStyles();
    const { state } = useLocation();

    const [value, setValue] = useState(state?.selectedTab || 0);

    const handleChangeValue = (e, newValue) => {
        setValue(newValue);
    }

    return (
        <Container className={container}>
            <Paper className={paper} square>
                <Tabs
                    className={tabs}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="tabs"
                    centered
                    value={value}
                    onChange={handleChangeValue}
                >
                    <Tab label="Usluge" {...a11yProps(0)} className={tab} />
                    <Tab label="Procenat usluge/radnika" {...a11yProps(1)} className={tab} />
                </Tabs>
                <TabPanel value={value} index={0} className={tabPanel}>
                    <ArticlesList />
                </TabPanel>
                <TabPanel value={value} index={1} className={tabPanel}>
                    <PercentageList />
                </TabPanel>
            </Paper>
        </Container>
    )
}

export default ExpenseTabs;
